<template>
    <div>
        <div class="profile-style">
            <h5 class="mb-4">Payment Method in Event</h5>
            <div class="tabel-action tb-al mb-4 position-relative" :class="detail_event.type === 'STANDARD' ? 'pl-4' : ''">
                <div v-if="detail_event.type === 'STANDARD'" class="disabled-feature bdr-15" @click.prevent="$emit('alertPackage')">
                    <i class="uil uil-lock-alt"></i>
                </div>
                <button type="button" v-b-modal.modal-Paymod class="btn bg-white bdr-15 btn-block btn-lg"><i class="uil uil-plus mr-2"></i>Add Payment Method</button>
            </div>

            <draggable
                v-bind="dragOptions"
                v-model="paymodGroup"
                handle=".handle"
                @start="drag = true"
                @end="drag = false"
                >

                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <div v-for="(data,index) in paymodGroup" :key="data.id" class="link mb-3">
                        <div class="link-drag handle align-items-center d-flex">
                            <i class="uil uil-draggabledots"></i>
                        </div>
                        <div class="link-body">
                            <div class="link-content">
                                <div class="link-item pr-5">
                                    <div><strong>{{data.payment_name}}</strong></div>
                                </div>
                                <div class="link-switch d-flex align-items-center">
                                    <a href="#" v-b-modal.modal-Paymod v-on:click.prevent="ASSIGN_FORM_PAYMOD(data)" class="act mb-0">
                                        <i class="uil uil-pen"></i>
                                        <span class="link-tx"> Edit</span>
                                    </a>
                                    <a href="#" v-on:click.prevent="alertDelete(data.id,index)" class="act mb-0">
                                        <i class="uil uil-trash-alt"></i>
                                        <span class="link-tx"> Delete</span>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                </transition-group>

            </draggable>
        </div>

        <b-modal id="modal-Paymod" size="lg" centered hide-footer :title="modal_title" @hidden="CLEAR_FORM_PAYMOD">

            <ValidationObserver ref="form">
                <div class="row">

                    <div class="col-md-12">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Payment Type</label>
                                <select v-model="formpaymod.type" @input="clearPayment()" class="form-control">
                                    <option value="QRCODE">QRCODE</option>
                                    <option value="BANK">BANK</option>
                                    <option value="CUSTOM">CUSTOM</option>
                                </select>
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>


                    <template v-if="formpaymod.type === 'CUSTOM'">
                        <div class="col-md-12">
                            <validation-provider v-if="!formpaymod.photo" rules="required|mimes:image/jpeg,image/png,image/jpg" v-slot="{ errors, validate }">
                                <div class="form-group">
                                    <div class="mb-1">
                                        <label>Payment Logo</label>
                                    </div>
                                    <div class="btn-up d-flex align-items-center" v-on:click.prevent="$refs.inputImage.click()">
                                        <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                    </div>
                                    <input ref="inputImage"
                                            type="file"
                                            class="custom-file-input d-none"
                                            id="Thumbnail"
                                            v-on:change="onImageUpload"
                                            accept="image/jpeg,image/png,image/jpg"
                                            @input="validate" >

                                    <div class="invalid-input mt-3">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>

                            <div class="form-group" v-if="formpaymod.photo">
                                <div class="mb-1">
                                    <label>Payment Logo</label>
                                </div>
                                <button v-on:click.prevent="removeImageUpload()" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button>
                                <div class="input-group img-sh">
                                    <img :src="formpaymod.photo" class="img-responsive img-prf">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Payment Name</label>
                                    <input v-model="formpaymod.payment_name" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>
                        </div>

                        <div class="col-md-12">
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Payment Account Name</label>
                                    <input v-model="formpaymod.acc_name" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>
                        </div>

                        <div class="col-md-12">
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Payment Account Number</label>
                                    <input v-model="formpaymod.number" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>
                        </div>
                    </template>

                    <template v-if="formpaymod.type === 'BANK'">
                        <div class="col-md-12">
                            <validation-provider rules="required" v-slot="{ errors }">
                                <label>Choose Payment</label>
                                <div class="category-themes">
                                    <button class="btn mr-3 btn-outline-secondary"
                                            v-for="(data,index) in bank_list" :key="index"
                                            @click="formpaymod.payment_name = data.value"
                                            :class="formpaymod.payment_name === data.value ? 'active' : ''"
                                    >
                                        <img v-if="data.value !== 'CUSTOM'" width="80px" :src="require('@/assets/img/paymod/' + data.value +'.svg')">
                                        <div style="font-size: 17px;" v-if="data.value === 'CUSTOM'">CUSTOM</div>
                                        <input type="hidden" v-model="formpaymod.payment_name">
                                    </button>
                                </div>
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </validation-provider>
                        </div>

                        <div class="col-md-12" v-if="formpaymod.payment_name">
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Bank Account Name</label>
                                    <input v-model="formpaymod.acc_name" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>
                        </div>

                        <div class="col-md-12" v-if="formpaymod.payment_name">
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Bank Account Number</label>
                                    <input v-model="formpaymod.number" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>
                        </div>
                    </template>

                    <template v-if="formpaymod.type === 'QRCODE'">
                        <div class="col-md-12 mt-2">
                            <div class="form-group">
                                <label>Payment Name</label>
                                <input v-model="formpaymod.payment_name" type="text" class="form-control" name="categories">
                            </div>
                        </div>

                        <div class="col-md-12 mt-2">
                            <div class="form-group">
                                <label>Account Name</label>
                                <input v-model="formpaymod.acc_name" type="text" class="form-control" name="categories">
                            </div>
                        </div>

                        <div class="col-md-12">
                            <validation-provider v-if="!formpaymod.photo" rules="required|mimes:image/jpeg,image/png,image/jpg" v-slot="{ errors, validate }">
                                <div class="form-group">
                                    <div class="mb-1">
                                        <label>QR Photo</label>
                                    </div>
                                    <div class="btn-up d-flex align-items-center" v-on:click.prevent="$refs.inputImage.click()">
                                        <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                    </div>
                                    <input ref="inputImage"
                                            type="file"
                                            class="custom-file-input d-none"
                                            id="Thumbnail"
                                            v-on:change="onImageUpload"
                                            accept="image/jpeg,image/png,image/jpg"
                                            @input="validate" >

                                    <div class="invalid-input mt-3">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>

                            <div class="form-group" v-if="formpaymod.photo">
                                <div class="mb-1">
                                    <label>QR Photo</label>
                                </div>
                                <button v-on:click.prevent="removeImageUpload()" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button>
                                <div class="input-group img-sh">
                                    <img :src="formpaymod.photo" class="img-responsive img-prf">
                                </div>
                            </div>
                        </div>
                    </template>
                </div>

                <div class="text-right mt-4">
                    <button v-on:click="validationForm(formpaymod.id)" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                        Save Payment Method
                    </button>
                </div>

            </ValidationObserver>

        </b-modal>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver } from "vee-validate";
    import draggable from 'vuedraggable'

    export default{
        data(){
            return{
                drag: false,
                loading:false,
                modal_title : 'Add Payment Method',
                photo_file:'',

                bank_list:[{value:'BCA'},{value:'BRI'},{value:'MANDIRI'},{value:'PERMATA'},{value:'BNI'}],
                qr_list:[{value:'OVO'},{value:'GOPAY'},{value:'LINKAJA'},{value:'DANA'}]
            }
        },
        watch:{
            'formpaymod':function(val){
                if(val.id){
                    this.modal_title = 'Edit Payment Method'
                }else if(!val.id){
                    this.modal_title = "Add Payment Method"
                }
            },
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            draggable,
        },
        computed:{
            ...mapState('EventsControl', {
                detail_event: state => state.detail_event,
                formpaymod: state => state.formpaymod
            }),

            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            paymodGroup: {
                get() {
                    return this.detail_event.paymentmethod
                },
                set(value) {
                    this.SET_POSITION_PAYMOD(value)
                    this.updatePositionPaymod(value)
                }
            }
        },
        methods:{
            ...mapMutations('EventsControl', ['SET_POSITION_PAYMOD','CLEAR_FORM_PAYMOD','ASSIGN_FORM_PAYMOD']),
            ...mapActions('EventsControl', ['detailEvents','createPaymod','updatePaymod','deletePaymod','updatePositionPaymod']),

            clearPayment: function(){
                this.formpaymod.payment_name = ''
                this.formpaymod.acc_name = ''
                this.formpaymod.number = ''
                this.formpaymod.photo = ''
            },
            onImageUpload: function(event) {
                var input = event.target;

                if (input.files && input.files[0]) {

                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.formpaymod.photo = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
                this.photo_file = input.files[0]
            },
            removeImageUpload:function(){
                this.photo_file = ''
                this.formpaymod.photo = ''
            },
            validationForm: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        var formData = new FormData();
                        formData.append('type', this.formpaymod.type);
                        formData.append('payment_name', this.formpaymod.payment_name ? this.formpaymod.payment_name : '');
                        formData.append('acc_name', this.formpaymod.acc_name ? this.formpaymod.acc_name : '');
                        formData.append('number', this.formpaymod.number ? this.formpaymod.number : '');
                        formData.append('photo_file', this.photo_file);
                        formData.append('photo', this.formpaymod.photo ? this.formpaymod.photo : '');

                        if(id){
                            formData.append("_method", "put");

                            this.updatePaymod(formData).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Paymod')
                                this.detailEvents(this.$route.params.id)
                                this.CLEAR_FORM_PAYMOD()
                                this.photo_file = ''
                                this.$toast.success('Successfully Update Payment Method')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })

                        }else{

                            this.createPaymod(formData).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Paymod')
                                this.detailEvents(this.$route.params.id)
                                this.photo_file = ''
                                this.CLEAR_FORM_PAYMOD()
                                this.$toast.success('Successfully Added Payment Method')
                            }).catch((error) => {
                                this.loading = false
                                if(error.response.data.errors == 'package'){
                                    this.$toast.warning('Sorry, Upgrade your package to use this feature')
                                }else{
                                    this.$toast.warning('Sorry, Something Error')
                                }
                            })
                        }
                    }
                });
            },
            alertDelete:function(id,index){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this payment method data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deletePaymod(id).then(
                            this.$toast.success('Successfully Deleting Payment Method'),
                            this.detail_event.paymentmethod.splice(index, 1)
                        ).catch((error) => {
                            console.log(error)
                            this.$toast.warning('Sorry, Something Error')
                        })
                    }
                })
            },
        }
    }

</script>

<style scoped>
    .img-sh img{
        width: 300px;
    }
    .link-icon img,
    .link-icon .no-img{
        width: 60px;
        height: 60px;
    }
    .btn-outline-secondary.qr{
        width: 100px;
        height: 100px;
    }
    .category-themes .btn-outline-secondary.qr:nth-child(3) img{
        width: 45px !important;
    }
    .btn-outline-secondary{
        border-color: #e4e6fc;
    }
    .btn-outline-secondary.active,
    .btn-outline-secondary:hover {
        background: #e4e6fc !important;
        border-color: #e4e6fc !important;
    }

</style>
